import {defineMessages} from 'react-intl';

const messages = defineMessages({
    NEW: {
        id: 'export.new',
        defaultMessage: 'New'
    },
    PROCESSING: {
        id: 'export.processing',
        defaultMessage: 'Processing'
    },
    ERROR: {
        id: 'export.error',
        defaultMessage: 'Error'
    },
    TO_MANY: {
        id: 'export.toMany',
        defaultMessage: 'Error - To many records'
    },
    NO_GROUP: {
        id: 'export.noGroup',
        defaultMessage: 'Error - User group missing'
    },
    FINISH: {
        id: 'export.finish',
        defaultMessage: 'Finish'
    },
});

export default messages;
